export interface SemanticVisibilityInput {
  layerId: string;
  /** Retained at the render boundary; zoom does not affect layer visibility. */
  zoom: number;
  focusedLayerId: string | null;
  /** The user's persisted layer toggle. Explicitly hidden always wins. */
  userVisible: boolean;
}

/** Compose user intent and solo focus into one render decision. */
export function isLayerSemanticallyVisible(input: SemanticVisibilityInput): boolean {
  const { layerId, focusedLayerId, userVisible } = input;
  if (!userVisible) return false;
  if (focusedLayerId !== null) return focusedLayerId === layerId;
  return true;
}
